import React, {useMemo} from 'react';
import {AiOutlineLoading3Quarters} from 'react-icons/ai';
import {Grid} from '~/components';
import {asyncState} from '~/hooks';
import {usePolicySearchRequest} from './context';
import {PolicySearchGridColumns} from "~/pages/PolicySearchRequest/PolicySearchGridCells";

const PolicySearchGrid = ({ pageSize, currentPage, handlePageChange, totalRows, handlePageSizeChange, usePagination = true }) => {

    const { gridData, firmData, filteredRows  } = usePolicySearchRequest();

    const isLoading = useMemo(() => gridData.status === asyncState.PENDING, [gridData.status]);
    const rows = Array.isArray(filteredRows) ? filteredRows : [];

    const firms = useMemo(
        () => firmData.status === asyncState.SUCCESS ? firmData.value : [],
        [firmData.status]);

    return (
        <div className='w-full flex flex-col items-stretch justify-center my-4'>
            {isLoading ? (
                <AiOutlineLoading3Quarters className='text-primary-50 animate-spin m-auto' size='2rem' />
            ) : (
                <Grid
                    usePagination={usePagination}
                    data={rows}
                    columns={PolicySearchGridColumns(firms)}
                    maxRows={totalRows}
                    className='w-full rounded-md text-sm'
                    tableClassName='mb-2'
                    page={currentPage}
                    events={{
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange
                    }}
                    initialState={{
                        defaultPageSize: pageSize
                    }}
                />
            )}
        </div>
    );
};

export default PolicySearchGrid;

